export default __webpack_public_path__ + "static/media/turista-approximandose-a-isla-aillaquillen.6c18cbeb.jpeg";